export enum ActivityName {
    EXACT_META = 'EXACT_META',
    WORK_ORDER = 'WORK_ORDER',
    PRODUCT = 'PRODUCT',
    CLIENT = 'CLIENT',
}
